<script type="text/javascript">
    
    import moment from "moment";
    import Chart from "chart.js";
    import colorLib from '@kurkle/color';

    import { onDestroy, onMount } from "svelte";

    export let title = "Chart";
    // export let days = 30;
    export let data = null;

    export let keys = [];        // refers to property name in <day data>, one key for each line

    export let height = 400;	// height in pixels (numeric)

    let chart = null;
    let canvas = null;

    onMount(() => {
       updateChart();
    })
    onDestroy(()=>{
		if (chart !== null) {
			chart.destroy();
			chart = null;
		}
    });
    $: {
        updateChart();
    }

    export const updateData = () => {
        if (chart !== null) {
            // chart.data.datasets[0].data = Object.values(data);
			chart.data.labels = _generateDates();
			chart.data.datasets = _generateDataSets();
            chart.update();
        }
    };

    let _generateKeyedData = () => {
        let keyedData = {};
       
        // console.log("data", data);
        for(let i = 0; i < data.length; i++) 
        {
            // let useIndex = days - 1 - i; // reverse order for graph. 
            // if (typeof data[useIndex] === "undefined") {
            //     continue; 
            // }
            let day = data[i].data;
            for(let k = 0; k < keys.length; k++) {
                let keyName = keys[k];
                let count = day.Graph_type[keyName];
                if (typeof keyedData[keyName] === "undefined") {
                    keyedData[keyName] = [];
                }
                keyedData[keyName].push(count); 
            }
        }
        return keyedData;
    };
    let _generateDates = () => {
        data.sort((a, b) => {
            return moment(a.Date) - moment(b.Date);
        });

        let dates = [];
        for(let i = 0; i < data.length; i++) 
        {
            let date_yyyymmdd = data[i].Date;
            dates.push(date_yyyymmdd);
        }
        return dates;
    };

    let _generateDataSets = () => {
        let keyedData = _generateKeyedData();
        let datasets = [];
        for(let k = 0; k < keys.length; k++) {
            let color = CHART_COLORS[Object.keys(CHART_COLORS)[k]];
            if (!color) {
                color = 'rgb(127, 127, 127)';
            }
            datasets.push({
                label: keys[k],
                data: keyedData[keys[k]], 
                fill: false,
                borderColor: color,
                backgroundColor: transparentize(color, 0.5),
                xAxisID: "x",
                lineTension: 0,
				steppedLine: false
            });
        }
        return datasets;
        
    }

    const CHART_COLORS = {
        green: 'rgb(75, 192, 192)',
        red: 'rgb(255, 99, 132)',
        orange: 'rgb(255, 159, 64)',
        yellow: 'rgb(255, 205, 86)',
        blue: 'rgb(54, 162, 235)',
        purple: 'rgb(153, 102, 255)'
    };
    function transparentize(value, opacity) {
        var alpha = opacity === undefined ? 0.5 : 1 - opacity;
        return colorLib(value).alpha(alpha).rgbString();
    }

    let updateChart = () => {
        // console.log("update chart", chart, canvas, data);
        if (chart === null && canvas !== null && data !== null) {
            
            const chartData = {
                labels: [],
                datasets: []
            };
            chartData.datasets = _generateDataSets();
            chartData.labels = _generateDates();
            console.log("chartData", chartData);

            const config = {
                type: 'line',
                data: chartData,
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            position: 'top',
                        },
                        title: {
                            display: true,
                            text: title
                        }
                    },
                    scales: {
                        xAxes: [
							{
                                id: "x",
                                type: "time",
								distribution: "linear",
								ticks: {
									source: 'auto'
								},
                                scaleLabel: {
									display: true,
									position: "bottom",
									labelString: "Time"
								},
								time: {
									minUnit: "day",
									tooltipFormat: "MMMM Do YYYY"
									// BUG: Using these crashes the browser with current  chart.js/moment versions.
									// unit: 'hourly',
									// displayFormats: {
									//  	hourly: "MMM D - HH:mm"
									// }
								},
                            }
                        ]
                    }
                },
            };
            chart = new Chart(canvas.getContext("2d"), config);
        }
        if (chart !== null && canvas !== null) {
            chart.options.scales.yAxes[0].ticks.suggestedMin = 0;
            chart.options.scales.yAxes[0].ticks.stepSize = 1;
            chart.update();
        }
    };
    
</script>

<p><b>{title}</b></p>
<div style={"position:relative; width:100%; min-height:" + height + "px; height:" + height + "px;"}>
    <canvas bind:this={canvas}></canvas>    
</div>